import { DashboardPage } from '../dashboard/DashboardPage';

/**
 * The front door, for everybody.
 *
 * ## Why there is no separate signed-out landing page
 *
 * There was one: a logo, a headline, and two buttons. It has been deleted.
 *
 * A site whose whole proposition is "there is music here you will not find
 * anywhere else" should not open with a paragraph *claiming* that. The
 * dashboard is the claim and its evidence at once - real tracks by real people,
 * with real numbers under them - and it makes the case for signing up far
 * better than any sentence about making the case.
 *
 * The page degrades rather than branching. Sections that need a viewer are
 * absent for a stranger because the server omits them (see
 * `ShowDashboardAction`), and the actions that need an account send people to
 * sign up at the moment they want to do the thing, which is the only moment the
 * ask is welcome.
 */
export function HomePage() {
  return <DashboardPage />;
}
